export const useFocus = () => {
    const getFocusableElements = (root = document.body) => {
        const focusables = [];

        const isFocusable = (el) => {
            const style = window.getComputedStyle(el);
            return (
                el.tabIndex >= 0 &&
                style.display !== 'none' &&
                style.visibility !== 'hidden' &&
                !el.disabled &&
                !el.closest('[inert]')
            );
        };

        const isAncestorHidden = (el) => {
            let current = el.parentElement;
            while (current) {
                const style = window.getComputedStyle(current);
                if (style.display === 'none') {
                    return true;
                }
                current = current.parentElement;
            }
            return false;
        };

        const pushFocusables = (node) => {
            if (node.nodeType !== 1) return;
            if (isFocusable(node) && !isAncestorHidden(node)) {
                focusables.push(node);
            }
            for (const child of node.children) {
                pushFocusables(child);
            }
        };

        pushFocusables(root);
        return focusables;
    };

    const getNextFocusableElement = (root = document.body, reverse = false) => {
        const focusable = getFocusableElements(root);

        const current = document.activeElement;
        const index = focusable.indexOf(current);

        if (reverse) {
            return focusable[index - 1] || null;
        } else {
            return focusable[index + 1] || null;
        }
    };

    return {
        getNextFocusableElement,
        getFocusableElements
    };
};
